import { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";

const OnBoarding = ({ person_id }) => { 
    const BaseUrl = process.env.REACT_APP_API;
    
      const typeOfAccount = {
        1: "Individual",
        2: "Entity",
      };
    
      const natureOfAccount = {
        1:"Investment in Equities",
        2:"Investment in Securities",
        3:"Investment in Bonds",
        4:"Investment in Commodities",
        5:"Investment in Mutual Funds",
        6:"Investment in Stocks",
        7:"Investment in Digital Assets"
      };
      const anticipateVolume = {
        1:"1 - 100,000 USD",
        2:"100,000 - 500,000 USD",
        3:"500,000 - 1,000,000 USD",
        4:"1,000,000 - 10,000,000 USD",
        5:"10,000,000 - 50,000,000 USD"
      };
      const sourceOfFunds = {
        1:"Salary",
        2:"Business Activity",
        3:"Savings",
        4:"Pension",
        5:"Inheritance",
        6:"Gift",
        7:"Bonus",
        8:"Indemnity/End of Service Payment",
        9:"Return on Investments",
        10:"Other",
      };
      const downloadLinkRef = useRef(null);
      const navigate = useNavigate();
      const [loading, setLoading] = useState(false);
      const [companyData, setCompanyData] = useState([]);
      const [countries, setCountry] = useState([]);
      const [signatureURL, setSignatureURL] = useState('');
    
      const [status, setStatus] = useState(""); // Status message
      const [loadingreport, setLoadingReport] = useState(false); // Loading state
    
      const handleGenerateReport = async () => {
        setStatus(""); // Clear any previous status
        setLoadingReport(true); // Start loading
      
        try {
          const clientId = person_id; // Replace with the actual client ID
          const response = await axios.get(`${BaseUrl}/generate-report/${clientId}`, {
            responseType: "blob", // Important for downloading files
          });
    
     
          
          // Get the filename from the 'Content-Disposition' header
          const contentDisposition = response.headers["content-disposition"];
    
          const fileName =companyData[0]?.full_legal_name ; // Default filename if not found in header
      
          // Create a Blob URL
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          const url = window.URL.createObjectURL(blob);
      
          // Create a temporary link element
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // Use the filename from the header
          document.body.appendChild(a);
          a.click(); // Trigger the download
          a.remove(); // Clean up
          window.URL.revokeObjectURL(url); // Free up memory
      
          setStatus("Generated"); // Update status to "Generated"
        } catch (error) {
          console.error("Error generating report:", error);
          setStatus("Failed to generate report"); // Handle error
        } finally {
          setLoadingReport(false); // Stop loading
        }
      };
      
      
      
      
    
      const formatDateToIST = (dateString) => {
        if (!dateString) return '';
      
        const date = new Date(dateString);
        
        const istOffset = 5.5 * 60 * 60 * 1000; 
        const localDate = new Date(date.getTime() + istOffset);
      
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
      
        return `${year}-${month}-${day}`;
      };
      const date_of_birth = useMemo(() => formatDateToIST(companyData[0]?.date_of_birth), [companyData]);
      const passport_issue_date = useMemo(() => formatDateToIST(companyData[0]?.passport_issue_date), [companyData]);
      const passport_expiry_date = useMemo(() => formatDateToIST(companyData[0]?.passport_expiry_date), [companyData]);
      const national_id_issue_date = useMemo(() => formatDateToIST(companyData[0]?.national_id_issue_date), [companyData]);
      const national_id_expiry_date = useMemo(() => formatDateToIST(companyData[0]?.national_id_expiry_date), [companyData]);
      const declaration_date = useMemo(() => formatDateToIST(companyData[0]?.declaration_date), [companyData]);
    
    
      useEffect(() => {
        const fetchSignature = async () => {
          try {
            const response = await axios.get(`${BaseUrl}/individual-digital-signature/${companyData[0]?.digital_signature}`, {
              responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = URL.createObjectURL(blob);
            setSignatureURL(url);
          } catch (error) {
            console.error('Error fetching digital signature:', error);
          }
        };
    
        if (companyData[0]?.digital_signature) {
          fetchSignature();
        }
      }, [companyData[0]?.digital_signature]);
    
      useEffect(() => {
        const fetchCountries = async () => {
          try {
            const response = await fetch(`${BaseUrl}/countries`);
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setCountry(data);
          } catch (error) {
            console.error("Failed to fetch countries:", error);
          }
        };
        fetchCountries();
      }, [BaseUrl]);
    
      useEffect(() => {
        const fetchCompanyData = async () => {
          try {
            setLoading(true);
    
            const response = await axios.post(`${BaseUrl}/getBasicInfoAdmin`, {
              person_id,
            });
    
            setLoading(false);
            setCompanyData(response.data);
          } catch (error) {
            console.log(error.message || "Error fetching company data");
          }
        };
    
        fetchCompanyData();
      }, [BaseUrl, person_id]);
    
    
    
    
      const [isReadOnly, setReadOnly] = useState(false);
          
      const handleDownload = async (filename) => {
        const response = await fetch(`${BaseUrl}/download/ind/${filename}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          toast.success("File downloaded successfully.");
    
          // Create a temporary anchor element to trigger the download
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          // Ensure downloadLinkRef.current is not null before accessing its properties
          if (downloadLinkRef.current) {
            downloadLinkRef.current.href = url;
            downloadLinkRef.current.setAttribute("download", filename);
            downloadLinkRef.current.click();
          } else {
            console.error("downloadLinkRef.current is null");
          }
        } else {
          return;
        }
      };
    
    
      const handlePrint = () => {
        window.print();
      };

  return (
    <>

      <div className="page-content">
        <div className="container-fluid">
          <div id="printableArea">
          <div id="completeform">
            <form id="mform">
              
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">

                  <div className="d-flex justify-content-between">
                     {/* <button
      className="btn btn-primary"

        onClick={handleGenerateReport}
        disabled={loadingreport}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: loadingreport ? "not-allowed" : "pointer",
        }}
      >
        {loadingreport ? "Generating..." : "Generate Report"}
      </button> */}
         
                {/* <button
                  hidden ={isReadOnly}
                  type="button"
                  className="btn btn-primary"
                  onClick={handlePrint}
                >
                  Print
                </button> */}
              </div>
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        Basic Info
                      </h4>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Full Legal Name :
                            </th>
                            <td>{companyData[0]?.full_legal_name}</td>
                          </tr>
                          {companyData[0]?.other_names_used ?
                          <tr>
                            <th scope="row" className="fw-bold">
                            Other Name:
                            </th>
                            <td>{companyData[0]?.other_names_used}</td>
                          </tr>
                          :''}
                          <tr>
                            <th scope="row" className="fw-bold">
                            Date of Birth:
                            </th>
                            <td>
                              {
                                date_of_birth
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Place of Birth:
                            </th>
                            <td>{companyData[0]?.place_of_birth}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Nationality :
                            </th>
                            <td>{companyData[0]?.nationality}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Passport Number:
                            </th>
                            <td>{companyData[0]?.passport_number}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Issue Date:
                            </th>
                            <td>{passport_issue_date}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Expiry Date:
                            </th>
                            <td>
                              {passport_expiry_date}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Place of Passport Issue:
                            </th>
                            <td>
                              {companyData[0]?.passport_issue_place}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            National ID Number:
                            </th>
                            <td>
                              {companyData[0]?.national_id_number}
                            </td>
                          </tr>
                          <tr>
                            <th scope="ropassport_expiry_datew" className="fw-bold">
                            Issue Date:
                            </th>
                            <td>
                              {national_id_issue_date}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Expiry Date:
                            </th>
                            <td>
                              {national_id_expiry_date}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Place of ID Issue:
                            </th>
                            <td>
                              {companyData[0]?.national_id_issue_place}
                            </td>
                          </tr>
                          
                          <tr>
                            <th scope="row" className="fw-bold">
                             Type of Account:
                            </th>
                            <td>
                              {typeOfAccount[companyData[0]?.type_of_account ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Nature of Account:
                            </th>
                            <td>
                              {natureOfAccount[companyData[0]?.nature_of_account ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Anticipated Volume:
                            </th>
                            <td>
                              {anticipateVolume[companyData[0]?.anticipated_volume  ]}
                            </td>
                          </tr>
                          
                          <tr>
                            <th scope="row" className="fw-bold">
                            Occupation :
                            </th>
                            <td>
                              {companyData[0]?.occupation}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Employer Name :
                            </th>
                            <td>
                              {companyData[0]?.employer_name}
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" className="fw-bold">
                            Source of Funds:
                            </th>
                            <td>
                              {sourceOfFunds[companyData[0]?.source_of_funds  ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Reason for Opening Account:
                            </th>
                            <td>
                              {[companyData[0]?.reason_for_opening_account  ]}
                            </td>
                          </tr>
                          {companyData[0]?.pep_name ?
                          <tr>
                            <th scope="row" className="fw-bold">
                            PEP Name:
                            </th>
                            <td>
                              {[companyData[0]?.pep_name  ]}
                            </td>
                          </tr>
                          : ""}
                         {companyData[0]?.position_held ?
                          <tr>
                            <th scope="row" className="fw-bold">
                            Position Held:
                            </th>
                            <td>
                              {[companyData[0]?.position_held  ]}
                            </td>
                          </tr>
                          : ""}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        Contact Info
                      </h4>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Full Permanent Address :
                            </th>
                            <td>{companyData[0]?.full_permanent_address}</td>
                          </tr>
                          
                          <tr>
                            <th scope="row" className="fw-bold">
                              Telephone:
                            </th>
                            <td>{companyData[0]?.telephone}</td>
                          </tr>
                          {companyData[0]?.fax ?
                          <tr>
                            <th scope="row" className="fw-bold">
                              Fax{" "}
                              <small className="text-muted">(Optional)</small>:
                            </th>
                            <td>{companyData[0]?.fax}</td>
                          </tr>
                          : ""}
                          <tr>
                            <th scope="row" className="fw-bold">
                              E-Mail:
                            </th>
                            <td>{companyData[0]?.email}</td>
                          </tr>
                          
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        KYC Documents
                      </h4>
                      <div className="text-muted">
                        <small>
                          The file size must be under 10 MB and only PDF format
                          is accepted.
                        </small>
                      </div>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Passport Copy:
                            </th>
                            <td>
                              {companyData[0]?.passport_copy} &nbsp;
                              {companyData[0]?.passport_copy && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-4"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.passport_copy
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            National ID:
                            </th>
                            <td>
                              {companyData[0]?.national_id} &nbsp;
                              {companyData[0]?.national_id && (
                                <span
                                hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.national_id
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Other Document:
                            </th>
                            <td>
                              {companyData[0]?.other_documents} &nbsp;
                              {companyData[0]?.other_documents && (
                                <span
                                hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.other_documents
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                        
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row justify-content-center">
                <div className="col-lg-12">
                <div className="card">
  <div className="card-header">
    <h4 className="card-title fw-bold" style={{ color: "#776ad8" }}>
      Declarations
    </h4>
  </div>
  <div className="card-body">
    {/* Declaration and Signature Section */}
    <div className="declaration-signature">
      {companyData[0]?.acting_on_my_behalf ?
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="acting_on_my_behalf"
          name="acting_on_my_behalf"
          checked={ companyData[0]?.acting_on_my_behalf}
        />
        <label className="form-check-label" htmlFor="acting_on_my_behalf">
          I/We hereby confirm that I/we are acting and would, in future will
          also be acting on my/our behalf for the purpose of transactions,
          new accounts or providing any further information required by Blue
          Aster Capital BSC ©.
        </label>
      </div>
      :""}
        
      <div className="form-check">
      <input
          className="form-check-input"
          type="checkbox"
          id="information_true"
          name="information_true"
          checked={companyData[0]?.information_true}
        />
        <label className="form-check-label" htmlFor="information_true">
          I/We hereby confirm the information provided above is true, accurate
          and complete. Subject to applicable local laws, I/we hereby consent
          for Blue Aster Capital BSC © or any of its affiliates to share our
          information with domestic or overseas regulators or tax authorities
          where necessary.
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="notify_on_change"
          name="notify_on_change"
          checked={companyData[0]?.notify_on_change}
        />
        <label className="form-check-label" htmlFor="notify_on_change">
          I/We agree and undertake to notify Blue Aster Capital BSC © within
          30 calendar days if there is a change in any information which I/we
          have provided.
        </label>
      </div>
      <div className="form-group mt-3">
        <label htmlFor="name " className="fw-bold ms-2">Name / Authorised Signatory Name:</label> {companyData[0]?.signatory_name}
      </div>
      {companyData[0]?.digital_signature ?
      <div className="form-group">
        <label htmlFor="signature" className="fw-bold ms-2">Digital Signature:</label><br />
        <div
          className="border rounded shadow-sm p-2 bg-light"
          style={{ display: 'inline-block', width: '300px', height: '200px' }}
        >
        <img src={signatureURL} alt="Digital Signature" style={{ maxWidth: '100%', height: 'auto' }} />

        </div> 
      </div>
      :""}
      <div className="form-group">
        <label htmlFor="date" className="fw-bold ms-2">Declaration Date:</label> {declaration_date}
        
      </div>
    </div>

    
  </div>
</div>

                </div>
              </div>

            </form>
            <a
              ref={downloadLinkRef}
              style={{ display: "none" }}
              href={() => false}
            ></a>
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBoarding;